import { render, staticRenderFns } from "./ReservedDiv.vue?vue&type=template&id=31a5da32&scoped=true&"
import script from "./ReservedDiv.vue?vue&type=script&lang=js&"
export * from "./ReservedDiv.vue?vue&type=script&lang=js&"
import style0 from "./ReservedDiv.vue?vue&type=style&index=0&id=31a5da32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a5da32",
  null
  
)

export default component.exports